module.exports = __webpack_public_path__ + "static/media/study220713.c7faea38.png";